<div
	class="modal fade"
	id="inactivityModal"
	tabindex="-1"
	aria-labelledby="inactivityModal"
	aria-hidden="true"
	data-bs-backdrop="static"
	data-bs-keyboard="false"
>
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-body p-2 text-center">
				<p class="fs-16"><strong>Sesión a punto de expirar</strong></p>
				<p>
					Por inactividad, tu sesión se cerrará automáticamente en breve. Haz clic en el botón
					<strong>Mantener sesión activa</strong> para continuar activo.
				</p>
				<p class="text-muted">Se cerrara sesión en {{ timer }}</p>
				<button #dismiss class="btn btn-primary text-white" (click)="restart()" data-bs-dismiss="modal">
					Mantener sesión activa
				</button>
			</div>
		</div>
	</div>
</div>
